import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface PageLayoutProps {
  children: React.ReactNode;
  maxWidth?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = '1200px'
}) => {
  const { getThemeStyles } = useTheme();
  const themeStyles = getThemeStyles();

  return (
    <div style={{
      padding: '20px',
      backgroundColor: themeStyles.background,
      color: themeStyles.text,
      minHeight: '100vh'
    }}>
      <div style={{ maxWidth, margin: '0 auto' }}>
        {children}
      </div>
    </div>
  );
};

export default PageLayout;